import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';
import StageTypeAppResource from './StageTypeAppResource';
import WorkspaceTypeAppResource from './WorkspaceTypeAppResource';

class WorkspaceStageTypeAppResource extends AppResource {

    /**
     * @returns {string}
     */
    appResourceType() {
        return 'Workspace-Stage-Type';
    }

    /**
     * @returns {string}
     */
    appResourceApiPrefix() {
        return 'workspaces/stages/types';
    }

    /**
     * @returns {*[]}
     */
    hidden() {
        return super.hidden().concat([
            'uuid',
            'deleted_at',
            'created_at',
        ]);
    }

    /**
     * @returns {*[]}
     */
    fillable() {
        return [
            'workspaceTypeUuid',
            'stageTypeUuid',
            'sort',
            'workspaceType',
            'stageType',
        ];
    }

    /**
     * @returns {*[]}
     */
    relationMap() {
        return {
            workspaceType: WorkspaceTypeAppResource,
            stageType: StageTypeAppResource,
        };
    }

    /**
     * @returns {*[]}
     */
    relationForeignKeys() {
        return {
            workspaceType: 'workspace_type_uuid',
            stageType: 'stage_type_uuid',
        };
    }

    /**
     * @returns {*}
     */
    validationRules() {
        return {
            workspaceTypeUuid: {
                type: 'string',
                presence: true,
            },
            stageTypeUuid: {
                type: 'string',
                presence: true,
            },
            sort: {
                type: 'string',
                presence: true,
            },
        };
    }

}

export default WorkspaceStageTypeAppResource;
